import "./AppointmentBookingSystems.module.css";
import Header from "@/reusable_sections/Header";
import SchedulingAutomation from "./sections/SchedulingAutomation";
import Booking from "./sections/Booking";
import BookingImpact from "./sections/BookingImpact";
import Footer from "@/reusable_sections/Footer";
export default function AppointmentBookingSystemsPage() {
  return <div>
      <Header />
      <SchedulingAutomation />
      <BookingImpact />
      <Booking />
      <Footer />
    </div>;
}